module.exports = __webpack_public_path__ + "img/07.48c58c7e.png";